// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splash {
  text-align: center;
}

.splash__center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0 32px;
}

.splash__logo {
  width: 190px;
  height: auto;
  object-fit: contain;
  transform: scaleX(-1);
  filter: drop-shadow(0 8px 14px rgba(28, 27, 26, 0.16));
}

.splash__word {
  font-size: 3.4rem;
  margin-top: 22px;
}

.splash__tag {
  margin-top: 10px;
}

.splash__foot {
  padding: 0 32px calc(env(safe-area-inset-bottom, 0px) + 40px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
}

.splash__dots {
  display: flex;
  gap: 7px;
}
.splash__dots i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--palette-border-strong);
  opacity: 0.25;
  animation: splashDot 1.2s infinite;
}
.splash__dots i:nth-child(2) {
  animation-delay: 0.18s;
}
.splash__dots i:nth-child(3) {
  animation-delay: 0.36s;
}
@keyframes splashDot {
  0%,
  80%,
  100% {
    opacity: 0.22;
  }
  40% {
    opacity: 1;
    background: var(--palette-primary);
  }
}
@media (prefers-reduced-motion: reduce) {
  .splash__dots i {
    animation: none;
    opacity: 0.4;
  }
}

.splash__defn {
  max-width: 320px;
  text-align: center;
  border-top: 1px solid var(--palette-border);
  padding-top: 16px;
}
.splash__defn-head {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.12rem;
  letter-spacing: 0.01em;
}
.splash__defn-head .pron {
  font-weight: 400;
  font-style: italic;
  color: var(--palette-text-muted);
  font-size: 0.95rem;
}
.splash__defn-head .pos {
  font-style: italic;
  color: var(--palette-primary);
  font-size: 0.95rem;
}
.splash__defn-body {
  font-family: var(--font-display);
  font-style: italic;
  color: var(--palette-text);
  font-size: 1rem;
  line-height: 1.45;
  margin-top: 7px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/loadingScreen.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;;;IAGE,aAAa;EACf;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;AACF;AACA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".splash {\n  text-align: center;\n}\n\n.splash__center {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 0 32px;\n}\n\n.splash__logo {\n  width: 190px;\n  height: auto;\n  object-fit: contain;\n  transform: scaleX(-1);\n  filter: drop-shadow(0 8px 14px rgba(28, 27, 26, 0.16));\n}\n\n.splash__word {\n  font-size: 3.4rem;\n  margin-top: 22px;\n}\n\n.splash__tag {\n  margin-top: 10px;\n}\n\n.splash__foot {\n  padding: 0 32px calc(env(safe-area-inset-bottom, 0px) + 40px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 22px;\n}\n\n.splash__dots {\n  display: flex;\n  gap: 7px;\n}\n.splash__dots i {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--palette-border-strong);\n  opacity: 0.25;\n  animation: splashDot 1.2s infinite;\n}\n.splash__dots i:nth-child(2) {\n  animation-delay: 0.18s;\n}\n.splash__dots i:nth-child(3) {\n  animation-delay: 0.36s;\n}\n@keyframes splashDot {\n  0%,\n  80%,\n  100% {\n    opacity: 0.22;\n  }\n  40% {\n    opacity: 1;\n    background: var(--palette-primary);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .splash__dots i {\n    animation: none;\n    opacity: 0.4;\n  }\n}\n\n.splash__defn {\n  max-width: 320px;\n  text-align: center;\n  border-top: 1px solid var(--palette-border);\n  padding-top: 16px;\n}\n.splash__defn-head {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.12rem;\n  letter-spacing: 0.01em;\n}\n.splash__defn-head .pron {\n  font-weight: 400;\n  font-style: italic;\n  color: var(--palette-text-muted);\n  font-size: 0.95rem;\n}\n.splash__defn-head .pos {\n  font-style: italic;\n  color: var(--palette-primary);\n  font-size: 0.95rem;\n}\n.splash__defn-body {\n  font-family: var(--font-display);\n  font-style: italic;\n  color: var(--palette-text);\n  font-size: 1rem;\n  line-height: 1.45;\n  margin-top: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
